<template>
  <div class="text-xs-center">
    <v-btn
      v-if="!menu"
      small
      icon
      class="ma-0"
      @click="menu = true"
    >
      <v-icon
        small
        color="grey lighten-1"
      >
        filter_list
      </v-icon>
    </v-btn>
    <v-menu
      v-else
      v-model="menu"
      :nudge-top="370"
      :max-width="1100"
      :max-height="696"
      offset-x
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          icon
          class="ma-0"
          v-on="on"
        >
          <v-icon
            small
            color="grey lighten-1"
          >
            filter_list
          </v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="py-0">
          <v-layout column>
            <v-flex>
              <h2 class="title my-3">
                Фильтр
              </h2>
            </v-flex>
            <v-layout row>
              <v-flex xs6>
                <v-select
                  v-model="selected"
                  :items="savedFilters"
                  label="Сохранённые фильтры"
                  hide-details
                  item-text="title"
                  item-value="id"
                  return-object
                  menu-props="offsetY"
                  outline
                  clearable
                  no-data-text="Данных нет"
                  @click:clear="clearFilter"
                  @input="getSavedFilter"
                >
                  <template v-slot:selection="data">
                    <span :selected="data.selected">
                      {{ data.item.title }}
                    </span>
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-tile-content v-text="data.item.title" />
                      <v-list-tile-action>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-if="data.item.isShared"
                              color="blue accent-1"
                              v-on="on"
                            >
                              flag
                            </v-icon>
                          </template>
                          <span>Общий фильтр</span>
                        </v-tooltip>
                      </v-list-tile-action>
                    </template>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs2>
                <v-layout>
                  <v-menu
                    v-model="menuSave"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    :disabled="isDisabledFilter"
                    menu-props="offsetY"
                  >
                    <v-btn
                      slot="activator"
                      icon
                      small
                      :disabled="isDisabledFilter"
                      class="mb-0 mt-3"
                    >
                      <v-icon color="grey darken-1">
                        save
                      </v-icon>
                    </v-btn>
                    <v-card>
                      <v-card-text>
                        <v-text-field
                          v-model="filterTitle"
                          label="Имя фильтра"
                        />
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn
                          small
                          flat
                          color="primary"
                          :disabled="!filterTitle"
                          @click="saveFilter"
                        >
                          Сохранить
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                  <v-btn
                    v-if="selected"
                    icon
                    small
                    class="mb-0 mt-3 ml-0 mr-3"
                    :disabled="isDisabledFilter || !selected"
                    @click="deleteFilter(selected)"
                  >
                    <v-icon color="grey darken-1">
                      delete
                    </v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-switch
                  v-model="isShared"
                  hide-details
                  label="Общий фильтр"
                  class="mx-2 mt-1"
                  :disabled="isDisabledFilter || !selected"
                  @change="changedIsShared"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-layout column>
            <v-flex>
              <v-layout>
                <v-autocomplete
                  v-model="filter.route"
                  :items="routes"
                  item-text="title"
                  hide-no-data
                  hide-details
                  outline
                  :height="44"
                  clearable
                  return-object
                  label="Номер маршрута"
                  class="ma-1"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <DecimalEditor
                  v-model="filter.volume.from"
                  :clearable="true"
                  label="Объем с"
                  hide-details
                  outline
                  height="44"
                  class="ma-1"
                />
                <DecimalEditor
                  v-model="filter.volume.to"
                  :clearable="true"
                  label="Объем по"
                  hide-details
                  outline
                  height="44"
                  class="ma-1"
                />
                <DecimalEditor
                  v-model="filter.weight.from"
                  :clearable="true"
                  label="Вес с"
                  hide-details
                  outline
                  height="44"
                  class="ma-1"
                />
                <DecimalEditor
                  v-model="filter.weight.to"
                  :clearable="true"
                  label="Вес по"
                  hide-details
                  outline
                  height="44"
                  class="ma-1"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-autocomplete
                  v-model="filter.shipping"
                  :items="shippings"
                  item-text="title"
                  hide-no-data
                  hide-details
                  outline
                  :height="44"
                  clearable
                  return-object
                  label="Поставка"
                  class="ma-1"
                />
                <v-autocomplete
                  v-model="filter.sender"
                  :items="senders"
                  hide-no-data
                  hide-details
                  outline
                  :height="44"
                  clearable
                  label="Продавец"
                  class="ma-1"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <app-date-picker
                  v-model="filter.readyDate.from"
                  label="Готовность с"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.readyDate.to"
                  label="Готовность по"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.deliveryToUnloadingPlaceDate.from"
                  label="Желаемая доставка с"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.deliveryToUnloadingPlaceDate.to"
                  label="Желаемая доставка по"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-autocomplete
                  v-model="filter.phaseType"
                  :items="phaseTypes"
                  item-text="title"
                  hide-no-data
                  hide-details
                  outline
                  :height="44"
                  clearable
                  return-object
                  label="Тип звена"
                  class="ma-1"
                />
                <v-autocomplete
                  v-model="filter.warehouseType"
                  :items="warehouseTypes"
                  hide-no-data
                  hide-details
                  outline
                  :height="44"
                  clearable
                  label="Статус на складе"
                  class="ma-1"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <app-date-picker
                  v-model="filter.arriveToWarehouseDate.from"
                  label="Прибытие на склад с"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.arriveToWarehouseDate.to"
                  label="Прибытие на склад по"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.carLoadingDate.from"
                  label="Погрузка в машину с"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
                <app-date-picker
                  v-model="filter.carLoadingDate.to"
                  label="Погрузка в машину по"
                  :clearable="true"
                  :without-initial-data="true"
                  :incoming-class="'ma-1'"
                />
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.region"
                    :elements="regions"
                    :is-elem-typeof-object="true"
                    filter-name="region"
                    label="Регион"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.district"
                    :elements="districts"
                    :is-elem-typeof-object="true"
                    filter-name="district"
                    label="Область"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.city"
                    :elements="cities"
                    :is-elem-typeof-object="true"
                    filter-name="city"
                    label="Город погрузки"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.loadingPlace"
                    :elements="loadingPlaces"
                    filter-name="loadingPlace"
                    label="Место погрузки"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex>
              <v-layout>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.client"
                    :elements="clients"
                    :is-elem-typeof-object="true"
                    filter-name="client"
                    label="Клиент"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
                <v-flex xs6>
                  <MultipleSelect
                    v-model="filter.clientAlias"
                    :elements="clientAliases"
                    filter-name="clientAlias"
                    label="Клиент по документам"
                    class="ma-1"
                    @change="changeFilterItem"
                  />
                </v-flex>
              </v-layout>
              <v-flex>
                <MultipleSelect
                  v-model="filter.warehouse"
                  :elements="warehouses"
                  filter-name="warehouse"
                  label="Склад"
                  class="ma-1"
                  @change="changeFilterItem"
                />
              </v-flex>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            small
            @click="changeFilter"
          >
            Применить
          </v-btn>
          <v-btn
            small
            @click="menu = !menu"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import MultipleSelect from "../../../components/selection-field/MultipleSelect.vue";
import _ from "lodash";
import * as dataListApi from "../../../backend/dataListApi.js";
import { userRoles } from "../../../enums/user-roles.js";
import auth from "../../../auth.js";

export default {
  components: { MultipleSelect },
  data() {
    return {
      menu: false,
      filter: null,
      filterMenu: false,
      isChanged: false,
      selected: null,
      menuSave: false,
      filterTitle: "",
      isShared: false,
      store: "routePlanning",
    };
  },
  computed: {
    planningItems() {
      return this.$store.getters["routePlanning/getPlanningData"];
    },
    loadingPlaces() {
      return this.getItems("loadingPlace");
    },
    routes() {
      return this.getRoutes();
    },
    shippings() {
      return this.getItems("shipping");
    },
    senders() {
      return this.getItems("sender");
    },
    phaseTypes() {
      return this.getItems("phaseType");
    },
    warehouseTypes() {
      return this.getItems("warehouseType");
    },
    regions() {
      return this.getItems("region");
    },
    districts() {
      return this.getItems("district");
    },
    cities() {
      return this.getItems("city");
    },
    clients() {
      return this.getItems("client");
    },
    clientAliases() {
      return this.getItems("clientAlias");
    },
    warehouses() {
      return this.getItems("warehouse");
    },
    storeFilter() {
      return this.$store.getters["routePlanning/dataTableFilter"];
    },
    savedFilters: {
      get() {
        return this.$store.getters["routePlanning/savedFilters"];
      },
      set(savedFilters) {
        this.$store.commit("routePlanning/setSavedFilters", savedFilters);
      },
    },
    quickFilter() {
      return this.$store.getters["routePlanning/quickFilter"];
    },
    storeIsShared: {
      get() {
        return this.$store.getters[`${this.store}/isShared`];
      },
      set() {
        return this.$store.commit(`${this.store}/setIsShared`, this.isShared);
      },
    },
    isDisabledFilter() {
      if (!this.selected) {
        return;
      }
      const user = auth.getUser();
      if (user.roles.find((r) => r.id === userRoles.Admin) || user.id === this.selected?.userId) {
        return false;
      }
      return true;
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.filter = this.copyFilter(this.storeFilter);
        this.isShared = this.storeIsShared;
        if (this.quickFilter) {
          this.selected = this.quickFilter;
          this.filterTitle = this.selected.title;
        }
      } else {
        this.filter = null;
        this.selected = null;
        this.filterTitle = "";
        this.isChanged = false;
        this.isShared = false;
      }
    },
    menuSave(value) {
      if (value) {
        if (this.selected) {
          this.filterTitle = this.selected.title;
        }
      } else {
        this.filterTitle = "";
      }
    },
  },
  created() {
    this.$store.dispatch("routePlanning/getSavedFilters");
    this.filter = this.copyFilter(this.storeFilter);
    this.selected = this.quickFilter;
    this.changeFilter();
  },
  methods: {
    getItems(value) {
      const items = [];
      this.planningItems.forEach((i) => {
        if (!i[value]) {
          return;
        }
        items.push(i[value]);
      });
      return _.uniqWith(items, _.isEqual);
    },
    getRoutes() {
      const items = [];
      this.planningItems.forEach((i) => {
        if (!i.route && !i.draft) {
          return;
        }
        const item = {
          id: i.route?.id || i.draft?.id,
          title: i.route?.title || i.draft?.title,
        };
        items.push(item);
      });
      return _.uniqWith(items, _.isEqual);
    },
    changeFilter() {
      this.$store.commit("routePlanning/setDataTableFilter", {
        ...this.filter,
      });
      this.menu = false;
      this.storeIsShared = this.isShared;
      this.$store.commit("routePlanning/setQuickFilter", this.selected);
      this.$emit("change", this.filter);
    },
    copyFilter(source) {
      const copy = {};
      for (const prop in source) {
        if (typeof source[prop] === "object") {
          copy[prop] = { ...source[prop] };
        }
        if (Array.isArray(source[prop])) {
          copy[prop] = source[prop].map((i) => {
            return i;
          });
        }
        if (typeof source[prop] === "string") {
          copy[prop] = source[prop];
        }
      }
      return copy;
    },
    async getSavedFilter(filter) {
      if (filter) {
        const res = await dataListApi.getSavedFilter(filter.id);
        this.filter = this.copyFilter(res.data.Filter);
        this.isShared = res.data.IsShared;
      } else {
        this.filter = this.copyFilter(this.storeFilter);
      }
    },
    async saveFilter() {
      const filter = {
        title: this.filterTitle,
        page: this.store,
        filter: this.filter,
        isShared: this.isShared,
      };
      if (this.selected?.id) {
        const res = await dataListApi.updateSavedFilter(
          this.selected.id,
          filter,
        );
        this.$store.commit("routePlanning/setSavedFilters", res);
        this.selected = this.savedFilters.find((f) => f.title === filter.title);
        this.$store.commit("routePlanning/setQuickFilter", this.selected);
        this.menuSave = false;
        this.isChanged = false;
        this.showInfo("Фильтр изменён");
      } else {
        const res = await dataListApi.createSavedFilter(filter);
        this.$store.commit("routePlanning/setSavedFilters", res);
        this.selected = this.savedFilters.find((f) => f.title === filter.title);
        this.$store.commit("routePlanning/setQuickFilter", this.selected);
        this.menuSave = false;
        this.isChanged = false;
        this.showInfo("Фильтр добавлен");
      }
    },
    async deleteFilter(filter) {
      let confirmText;
      if (this.selected.isShared) {
        confirmText =
          "Это общий фильтр доступный всем пользователям. Подтверждая это действие, фильтр будет удален у всех пользователей системы. \n Удалить фильтр?";
      } else {
        confirmText = "Удалить фильтр?";
      }

      if (confirm(confirmText)) {
        const res = await dataListApi.deleteSavedFilter(this.store, filter.id);
        this.showInfo("Фильтр удалён");
        this.$store.commit("routePlanning/setSavedFilters", res);
        this.clearFilter();
      }
    },
    async changedIsShared() {
      if (this.selected) {
        const res = await dataListApi.shareSavedFilter(
          this.store,
          this.selected.id,
          this.isShared,
        );
        const message = this.isShared
          ? "Фильтр доступен всем пользователям"
          : "Фильтр не доступен всем пользователям";
        this.showInfo(message);
        this.$store.commit("routePlanning/setSavedFilters", res);
        this.selected.isShared = this.isShared;
      }
    },
    clearFilter() {
      this.$emit("clear");
      this.$store.commit("routePlanning/setQuickFilter", null);
      this.selected = null;
      this.isShared = false;
      this.filterTitle = "";
      this.filter = this.copyFilter(this.storeFilter);
    },
    changeFilterItem(value) {
      this.filter[value.prop] = value.item;
    },
  },
};
</script>
